// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/italic.js';

import { paths } from '../generated/italic';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('italic', Original, paths);
